import { render, staticRenderFns } from "./ForAutoBlock.vue?vue&type=template&id=35d419f6"
import script from "./ForAutoBlock.vue?vue&type=script&lang=js"
export * from "./ForAutoBlock.vue?vue&type=script&lang=js"
import style0 from "./ForAutoBlock.vue?vue&type=style&index=0&id=35d419f6&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d419f6')) {
      api.createRecord('35d419f6', component.options)
    } else {
      api.reload('35d419f6', component.options)
    }
    module.hot.accept("./ForAutoBlock.vue?vue&type=template&id=35d419f6", function () {
      api.rerender('35d419f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ForAutoBlock.vue"
export default component.exports